import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import ThemeProvider from '@catalytic/pushbot-ui/ThemeProvider';
import createTheme from '@catalytic/pushbot-ui/styles/theme';
import createPalette from '@catalytic/pushbot-ui/styles/palette';
import { watchListEnabled } from '../selectors/feature';
import featurePropTypes from '../types/feature';

@connect(
  state => ({ watchListEnabled: watchListEnabled(state) }),
  () => ({})
)
export default class ThemeProviderContainer extends PureComponent {
  static displayName = 'ThemeProviderContainer';

  static propTypes = {
    children: PropTypes.node,
    watchListEnabled: featurePropTypes
  };

  render() {
    const { children, watchListEnabled } = this.props;
    const type = watchListEnabled ? 'dark' : 'light';
    const theme = createTheme({ palette: createPalette({ type }) });
    return (
      <ThemeProvider key={type} {...{ theme }}>
        {children}
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./js/routes/ThemeProviderContainer.js